// Field and tab hints of the trip and hotel editor (rez 10). Keys are referenced from the hint
// registry (`apps/admin/src/lib/webHints/trip.ts`). A "web" text names "<page> → <section>" with
// the condition in brackets, without the "On the website:" prefix; a "backoffice" text continues
// "Not shown on the website, used for". `fields.<field>Hotel` is the text of the hotel variant,
// `tabs.<id>` the purpose of a tab whose content the website does not show.
export const trip = {
  fields: {
    title:
      "Trip page → hero (when there is no Hero title) and the H1 heading (when there is no Page heading); cards in listings and the search engine title; for a hotel Hotel page → heading",
    slug: "Page address → /zajezd/<address>, for a hotel /hotel/<address>",
    destinationId:
      "Destination page → Trips; cards in listings; hotel listing → destination filter",
    destinationTagIds:
      "Tagged destination page → Trips (a combined trip also shows on the pages of further destinations); hotel listing → destination filter",
    guideId: "Trip page → Your guide; Guide page → their trips",
    guideIdHotel:
      "Guide page → their trips (the hotel page does not show the trip's guide, it shows the destination specialists)",
    guideVideoUrl: "Trip page → Your guide (guide video)",
    difficultyLevel:
      "Trip listing → quick view; Trip page → FAQ (default question when the trip has no FAQ of its own)",
    tripKind:
      "Trip page → page layout (experience: What you will experience and What awaits you; otherwise Itinerary)",
    fulfillmentMode:
      "Trip page → Dates (fixed departures), or an inquiry with a calendar (on request); together with the type Stay the trip is shown on the hotel page",
    tripType: "Trip page → type badge below the description; trip listing → type filter",
    countryCodesText:
      "the offer PDF, the entry tasks of an order and template variables (countries of the trip)",
    tripStyle: "Trip listing → theme filter; menu → “By experience”",
    priceFrom: "Trip/hotel page → price in the booking panel; cards in listings",
    priceIsFrom:
      "Trip page → “from” next to the price in the booking panel and in the inquiry; cards in listings",
    priceOriginal:
      "Trip/hotel page → struck-through original price; cards in listings → SALE badge",
    durationHours:
      "Trip page → length of the experience in the hero (experience only); cards in listings and quick view",
    durationDays:
      "Trip page → length in the hero; cards in listings; for a hotel Hotel page → length of stay",
    groupSizeMin: "Trip page → group size and the default FAQ question; trip listing → quick view",
    groupSizeMax:
      "Trip page → group size and the default FAQ question; Dates → capacity of new departures",
    groupSizeOpenEnded:
      "Trip page → “from 1 person, by arrangement” instead of the upper limit, also in Dates; cards in listings",
    defaultMeetingPoint:
      "the meeting point in the customer portal and in the guide app (a departure can override it)",
    defaultMeetingTime:
      "the meeting time in the customer portal and in the guide app (a departure can override it)",
    shortDescription:
      "Cards in listings → teaser; search engines → page description (when there is no Meta description); for a hotel Hotel page → teaser below the “Why choose this hotel” heading (only with “Why choose” points, when there is no Page heading)",
    description:
      "Trip page → description below the H1 heading; for a hotel Hotel page → description",
    heroTitle: "Trip page → text over the opening photo (hero); empty = trip title",
    heading:
      "Trip page → H1 heading above the description (empty = Title); for a hotel Hotel page → teaser below the “Why choose this hotel” heading (only with “Why choose” points)",
    metaTitle: "Search engines → page title in search results",
    metaDescription: "Search engines → page description in search results",
    featuredImageId: "Trip/hotel page → main image; cards in listings",
    isFeatured: "Home page → featured trips; cards in listings → OUR TIP badge",
    isLastMinute:
      "Cards in listings → LAST MINUTE badge (unless a badge with a higher priority takes its place)",
    isForWomen: "Trip listing → “For women” filter",
    hasCzechGuide: "Trip page → Czech guide badge below the description; cards in listings → badge",
    tags: "Trip page → tags below the description",
    leadTimeHours:
      "Trip/hotel page → inquiry, the earliest day offered in the calendar (on-request trips only)",
    availableWeekdays:
      "Trip/hotel page → inquiry, the days the calendar offers (on-request trips only)",
    highlights: "Trip page → What you will experience (experience only)",
    highlightsHotel: "Hotel page → Why choose this hotel (point titles only)",
    schedule: "Trip page → What awaits you (programme of the experience, experience only)",
    hotelStars:
      "Hotel page → stars next to the heading; hotel card; stay listing → star filter (hotel only)",
    hotelMealPlans:
      "Hotel page → meal plans and surcharges in the inquiry; hotel card (hotel only)",
    hotelDepartures: "Hotel page → departure places in the inquiry (hotel only)",
    hotelFeatures:
      "Hotel page → focus badges below the heading; stay listing → focus filter (hotel only)",
    hotelRooms: "Hotel page → rooms and the room choice in the inquiry (hotel only)",
    hotelCoordinatesText:
      "Hotel page → Hotel location (map); trip listing in the Map view → the hotel's own pin",
    included: "Trip/hotel page → What's included",
    excluded: "Trip/hotel page → What's not included",
    note: "Trip/hotel page → note below What's included / What's not included",
    optionalActivities:
      "Hotel page → Optional trips (hotel only); for other trips only Offer PDF → optional activities",
    itinerary:
      "Trip page → Itinerary (not for an experience); always also Offer PDF → programme and the guide app",
    itineraryHotel:
      "the programme in the offer PDF and in the guide app (the hotel page does not read the itinerary)",
    galleryImageIds: "Trip/hotel page → Gallery",
    youtubeVideos: "Trip/hotel page → Videos",
    dates: "Trip page → Dates (fixed departures only)",
    components: "the bill of materials: proposed services and costs of new departures and orders",
    faqs: "Trip/hotel page → FAQ (a trip without its own questions shows the default ones)",
    socialReels: "Trip/hotel page → Get inspired (short social media videos)",
    mapImageId: "Trip page → Route map; trip listing → Routes view",
    mapImageIdHotel:
      "Trip listing → Routes view (the hotel page shows a map built from the coordinates on the Hotel tab)",
    guideRecommendation:
      "Trip page → Guide recommendation; for a hotel Hotel page → CK Go2 specialist's tip",
    relatedItems:
      "Trip page → Similar trips you might like (the manual choice first, topped up by the automatic one; published trips only)",
    upgradeIds: "Trip page → Premium upgrades; order → proposed items",
    upgradeIdsHotel: "proposed order items (the hotel page does not show premium upgrades)",
    relatedPageIds: "Trip page → More about this trip (published pages only)",
    status: "Trip/hotel page → the whole page is visible only in the Published state",
    tripInspirationLinks:
      "Inspiration page → Trips where you can experience it (on the selected inspirations); the trip page does not show the link",
    calculation:
      "the cost and selling price calculation and the prices in the offer PDF; “Apply to trip” overwrites the Price and the departure prices",
  },
  tabs: {
    itineraryHotel: "the offer PDF and the guide app (the hotel page does not read the itinerary)",
    hotelTrip:
      "the hotel page, once the trip is a Stay booked on request (the trip page does not read these fields)",
    components: "the bill of materials: proposed services and costs of new departures and orders",
    calculation: "the cost and selling price calculation and the prices in the offer PDF",
  },
};
